import {
  Configuration,
  Events,
  SignalConfigurationModel,
} from '@mm/state/model/SignalModel';
import Actions from '../actions/actions';
import signalConfigurationCRUDActions from '../actions/SignalConfigurationCRUDActions';
import { setBusy, setUnBusy } from './common/commonReducers';

type ActionType = {
  type: string;
  entity: Configuration;
  events: Events;
};

const initialState: SignalConfigurationModel = {
  busy: false,
  configuration: null,
  events: {},
  eventsByDay: undefined,
};

export const signalConfiguration = (
  state = initialState,
  action: ActionType,
) => {
  switch (action.type) {
    case signalConfigurationCRUDActions.busyAction:
      return setBusy(state);

    case signalConfigurationCRUDActions.retrievedAction: {
      return {
        ...state,
        configuration: action.entity,
        busy: false,
      };
    }
    case signalConfigurationCRUDActions.eventsRetrieved: {
      return {
        ...state,
        events: action.events.eventsByMetric,
        eventsByDay: action.events.eventsByDay,
        busy: false,
      };
    }
    case signalConfigurationCRUDActions.unbusyAction:
      return setUnBusy(state);
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
};
